import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { useState, useEffect } from 'react';

import logo from '../assets/images/logo.png'
import PlainButton from './PlainButton';
import BorderButton from './BorderButton';

const Footer = () => {

  const isMobile = useMediaQuery({ maxWidth: 551 });
  const isNotMobile = useMediaQuery({ minWidth: 552 });

  const [buttonSize, setButtonSize] = useState('');

  useEffect(() => {
    if (isMobile)     {
      setButtonSize('btn-sm');
    }

    if (isNotMobile) {
      setButtonSize('');
    }
  }, [isMobile, isNotMobile]);


  return (
    <>

      <footer className={`p-1 pt-5 pb-3 m-0 border-top border-3 border-bright-main bg-main`}>

        <div>
          <div className="d-flex flex-wrap align-items-center justify-content-center">
            {/* <a className={`navbar-brand  text-center mb-3`} href="/">
              <div className='font-custom'>Art Alive Art School</div>
              <img src={logo} width={"200"} className="d-block mx-auto" alt="Art Alive Logo" />
            </a> */}

            <div className="mx-auto d-flex flex-wrap gap-2 justify-content-center mb-3">
              <BorderButton button_border='bright-accent' url="/">Home</BorderButton>
              <BorderButton button_border='bright-accent' url="/about">About</BorderButton>
              <BorderButton button_border='bright-accent' url="/classes">Classes</BorderButton>
              <BorderButton button_border='bright-accent' url="/teachers">Teachers</BorderButton>
              <BorderButton button_border='bright-accent' url="/events">Events</BorderButton>
            {/* </div>

            <div className="d-flex flex-wrap gap-2 align-items-center justify-content-center"> */}
                {/* <a href="https://web.facebook.com/artaliveartschool#" target='_blank' className={`btn ${buttonSize} btn-bright-${} text-${}`}>
                  <i className="bi bi-facebook"></i>
                </a>
                <a href="https://www.instagram.com/art_alive_art_school/?utm_source=qr#" target='_blank' className={`btn ${buttonSize} btn-bright-${} text-${}`}>
                  <i className="bi bi-instagram"></i>
                </a> */}
                <PlainButton url='https://web.facebook.com/artaliveartschool#'><i className="bi bi-facebook"></i></PlainButton>
                <PlainButton url='https://www.instagram.com/art_alive_art_school/?utm_source=qr#'><i className="bi bi-instagram"></i></PlainButton>
                <PlainButton url='/contact'>Join</PlainButton>
                <PlainButton url='/contact'>Contact Us</PlainButton>
            </div>
          </div>

          <div className="text-center">
            <p>&copy; 2025 Art Alive. All rights reserved.</p>
          </div>
        </div>

      </footer>
        
    </>
    )
}

export default Footer;